import IncomingEmail from './incoming_email'
import PropTypes from 'prop-types'
import Email from './email'
import React from 'react'
import List from './list'

class EmailReader extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    contact: PropTypes.object,
    defaultQuery: PropTypes.object,
    email: PropTypes.object,
    email_campaign: PropTypes.object,
    endpoint: PropTypes.string,
    order: PropTypes.object,
    perspective: PropTypes.string,
    program: PropTypes.object,
    provider: PropTypes.object,
    refresh: PropTypes.string,
    registration: PropTypes.object,
    response: PropTypes.object,
    show_interactions: PropTypes.bool,
    show_outcome: PropTypes.bool,
    subscription: PropTypes.object,
    usage: PropTypes.object,
    user: PropTypes.object
  }

  static defaultProps = {
    endpoint: '/api/admin/emails',
    show_interactions: true,
    show_outcome: false
  }

  state = {
    selected: null
  }

  _handleSelect = this._handleSelect.bind(this)

  render() {
    const { selected } = this.state
    return (
      <div className="email-reader">
        <List { ...this._getList() } />
        <div className="email-reader-show">
          { document.body.clientWidth > 1024 && selected &&
            <>
              { selected.type === 'incoming' ?
                <IncomingEmail { ...this._getShow() } /> :
                <Email { ...this._getShow() } />
              }
            </>
          }
        </div>
      </div>
    )
  }

  _getList() {
    const { contact, defaultQuery, email, email_campaign, endpoint, order, program, perspective, refresh, registration, response, provider, show_interactions, show_outcome, subscription, usage, user } = this.props
    const { selected } = this.state
    return {
      contact,
      defaultQuery,
      email,
      email_campaign,
      endpoint,
      refresh,
      order,
      perspective,
      program,
      provider,
      registration,
      response,
      selected,
      show_interactions,
      show_outcome,
      subscription,
      usage,
      user,
      onChoose: this._handleSelect
    }
  }

  _getShow() {
    const { show_interactions, show_outcome } = this.props
    const { selected } = this.state
    const code = selected.code
    const uuid = selected.uuid
    return {
      key: code,
      code,
      uuid,
      show_outcome,
      show_interactions
    }
  }

  _handleSelect(selected) {
    this.setState({ selected })
    if(document.body.clientWidth > 1024) return
    this.context.router.push(`/admin/emails/${selected.code}`)
  }

}

export default EmailReader
